module.exports = __webpack_public_path__ + "static/media/gray_14.2bd08643.jpg";